import { AbstractControl, UntypedFormGroup, ValidatorFn } from '@angular/forms';

export function RangeValidation(): ValidatorFn {
  return (group: UntypedFormGroup) => {
    var fromControl: AbstractControl = group.controls['from'];
    var toControl: AbstractControl = group.controls['to'];
    if (fromControl.valid && toControl.valid) {

      if (fromControl.value > toControl.value) {
        return { 'range': true };
      }
      else
        return null;
    }

    return null;
  }
}

export function DateValidation(): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } => {
    var date = control.value;

    var invalidDate = { 'date': true };

    var regEx = /^\d{4}-\d{2}-\d{2}$/;
    if (!date.match(regEx)) {
      return invalidDate;
    }
    var d = new Date(date);
    if (Number.isNaN(d.getTime())) {
      return invalidDate;
    }
    if (d.toISOString().slice(0, 10) === date) {
      return null;
    }
    else {
      return invalidDate;
    }
  }
}
